module.exports = __webpack_public_path__ + "media/images/writer/story_achievement_mailer/ogp_image_100000-2fc751fbace3df1b108b7d390be8beae.png";